import { render, staticRenderFns } from "./LexnetView.vue?vue&type=template&id=3c57046c&scoped=true&lang=pug"
import script from "./LexnetView.vue?vue&type=script&lang=ts"
export * from "./LexnetView.vue?vue&type=script&lang=ts"
import style0 from "./LexnetView.vue?vue&type=style&index=0&id=3c57046c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c57046c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c57046c')) {
      api.createRecord('3c57046c', component.options)
    } else {
      api.reload('3c57046c', component.options)
    }
    module.hot.accept("./LexnetView.vue?vue&type=template&id=3c57046c&scoped=true&lang=pug", function () {
      api.rerender('3c57046c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Lexnet/LexnetView.vue"
export default component.exports